'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlt = exports.getQeId = exports.getSrc = exports.getImageBannerData = undefined;

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getImageBannerData = exports.getImageBannerData = function getImageBannerData(state) {
  return (0, _lodash2.default)(state.intlPage, 'cards[0].imageBanner');
};

var getSrc = exports.getSrc = (0, _reselect.createSelector)(getImageBannerData, function (imageBannerData) {
  return (0, _lodash2.default)(imageBannerData, 'imageUrls') || '';
});

var getQeId = exports.getQeId = (0, _reselect.createSelector)(getImageBannerData, function (imageBannerData) {
  return (0, _lodash2.default)(imageBannerData, 'qeId') || '';
});

var getAlt = exports.getAlt = (0, _reselect.createSelector)(getImageBannerData, function (imageBannerData) {
  return (0, _lodash2.default)(imageBannerData, 'alt') || '';
});